import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FestiveService } from '../../../../services/festive.service';

// Bump the version suffix to show a new announcement to users who dismissed the previous one
const DISMISS_KEY = 'elixir.marquee.newUi.v1.dismissed';

@Component({
  selector: 'app-announcement-marquee',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './announcement-marquee.component.html',
  styleUrls: ['./announcement-marquee.component.scss'],
})
export class AnnouncementMarqueeComponent {
  private readonly defaultMessages = [
    '🎉 Welcome to the new Elixir POS! ✨ It is now faster and easier to use 🚀',
    '🎉 புதிய Elixir POS-க்கு வரவேற்கிறோம்! ✨ இப்போது இன்னும் வேகமாகவும் எளிதாகவும் பயன்படுத்தலாம் 🚀',
  ];

  // A running festival takes over the strip, with its own dismiss key per festival and year.
  // Read live so a login into restaurant/pharmacy drops it straight away.
  private readonly festiveService = inject(FestiveService);
  // Cached per key so change detection doesn't hit localStorage every cycle
  private dismissed = new Map<string, boolean>();

  get messages(): string[] {
    return this.festiveService.festival?.messages ?? this.defaultMessages;
  }

  get visible(): boolean {
    const key = this.dismissKey;
    if (!this.dismissed.has(key)) this.dismissed.set(key, this.isDismissed(key));
    return !this.dismissed.get(key);
  }

  private get dismissKey(): string {
    const festival = this.festiveService.festival;
    return festival ? `elixir.marquee.${festival.id}${festival.start.slice(0, 4)}.dismissed` : DISMISS_KEY;
  }

  dismiss(): void {
    this.dismissed.set(this.dismissKey, true);
    try {
      localStorage.setItem(this.dismissKey, '1');
    } catch {
      // Storage blocked: the strip just comes back on next load
    }
  }

  private isDismissed(key: string): boolean {
    try {
      return localStorage.getItem(key) === '1';
    } catch {
      return false;
    }
  }
}
